<template>
  <div class="administration">
    <!-- LOGIN MODAL -->
    <div
      class="modal fade loginModal"
      id="loginModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body my-row">
            <form class="login" @submit.prevent="login(credentials)">
              <h2>Přihlášení</h2>

              <label for="email">E-mail</label>
              <input
                type="text"
                id="email"
                v-model="credentials.email"
                required
              />

              <label for="password">Heslo</label>
              <input
                type="password"
                id="password"
                v-model="credentials.password"
                required
              />

              <div class="loading-spinner" v-if="logging">
                <VaProgressCircle indeterminate />
              </div>

              <input class="btn-yellow" type="submit" value="Přihlásit se" />

              <p v-if="loginError" class="login-error">
                {{ loginError }}
              </p>
            </form>

            <div class="registration registration__info">
              <!-- Bootstrap 4 close -->
              <button
                type="button"
                class="close"
                aria-label="Close"
                data-dismiss="modal"
              >
                <font-awesome-icon :icon="['fa', 'times']" size="2x" />
              </button>

              <h2>Proč se registrovat?</h2>
              <ul>
                <li><span>Rychlejší nakupování</span></li>
                <li><span>Historie objednávek</span></li>
                <li><span>Nemusíš vyplňovat údaje</span></li>
                <li><span>FITMO novinky</span></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ADMIN UI -->
    <template v-if="authed">
      <div class="sideBar">
        <ul>
          <li @click="navigateAndClear(1)">Přidat produkt</li>
          <li @click="navigateAndClear(2)">Přehled produktů</li>
          <li @click="navigateAndClear(3)">Přehled kategorií</li>
          <li @click="navigateAndClear(4)">Přehled objednávek</li>
          <li @click="navigateAndClear(5)">Pořadí produktů</li>
          <li @click="navigateAndClear(6)">Feedy</li>
        </ul>
      </div>

      <div class="mainWrapper">
        <AddProduct v-if="showedMain === 1" />
        <AllProducts v-if="showedMain === 2" />
        <AllCategories v-if="showedMain === 3" />
        <AllOrders v-if="showedMain === 4" />
        <ProductOrders v-if="showedMain === 5" />
        <Feeds v-if="showedMain === 6" />
        <ProductEdit v-if="showedMain === 'edit'" />
      </div>
    </template>
  </div>
</template>

<script>
import axios from "@/api";
import AddProduct from "../components/admin/AddProduct";
import AllProducts from "../components/admin/AllProducts";
import AllCategories from "../components/admin/AllCategories";
import AllOrders from "../components/admin/AllOrders.vue";
import ProductOrders from "../components/admin/ProductOrders.vue";
import ProductEdit from "@/views/admin/ProductEdit.vue";
import Feeds from "../components/admin/Feeds.vue";
import { login } from "@/helpers/auth";

export default {
  components: {
    AddProduct,
    AllProducts,
    AllCategories,
    AllOrders,
    ProductOrders,
    ProductEdit,
    Feeds,
  },

  data() {
    return {
      showedMain: 2,
      authed: false,

      credentials: { email: "", password: "" },
      logging: false,
      loginError: "",

      _modalHiddenHandler: null,
    };
  },

  methods: {
    setAuthedFromStorage() {
      this.authed = !!sessionStorage.getItem("user");
    },

    navigateAndClear(viewId) {
      this.showedMain = viewId;

      if (this.$route.params.productId) {
        const { productId, ...rest } = this.$route.params;
        this.$router.push({ name: this.$route.name, params: rest });
      }
    },

    // ✅ tvrdý cleanup bootstrap modalu (BS4 často nechá backdrop / modal-open)
    cleanupModalArtifacts() {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";

      const backdrops = document.querySelectorAll(".modal-backdrop");
      backdrops.forEach((b) => b.remove());
    },

    attachModalHiddenRedirect() {
      const el = document.getElementById("loginModal");
      if (!el) return;

      if (this._modalHiddenHandler) {
        el.removeEventListener("hidden.bs.modal", this._modalHiddenHandler);
      }

      this._modalHiddenHandler = () => {
        // po zavření vždy uklidit zbytky
        this.cleanupModalArtifacts();

        // pokud pořád nejsem přihlášen -> pryč
        this.setAuthedFromStorage();
        if (!this.authed) {
          this.$router.push("/");
        }
      };

      el.addEventListener("hidden.bs.modal", this._modalHiddenHandler);
    },

    detachModalHiddenRedirect() {
      const el = document.getElementById("loginModal");
      if (el && this._modalHiddenHandler) {
        el.removeEventListener("hidden.bs.modal", this._modalHiddenHandler);
      }
      this._modalHiddenHandler = null;
    },

    openLoginModal() {
      const el = document.getElementById("loginModal");
      if (!el) return;

      this.attachModalHiddenRedirect();

      if (window.$ && typeof window.$(el).modal === "function") {
        window.$(el).modal("show");
        return;
      }

      // fallback
      el.classList.add("show");
      el.style.display = "block";
      document.body.classList.add("modal-open");
    },

    hideLoginModal() {
      const el = document.getElementById("loginModal");
      if (!el) return;

      if (window.$ && typeof window.$(el).modal === "function") {
        window.$(el).modal("hide");
        return;
      }

      el.classList.remove("show");
      el.style.display = "none";
      this.cleanupModalArtifacts();
    },

    forceLogoutAndRedirect() {
      sessionStorage.removeItem("user");
      this.$store.commit("updateUser", null);
      this.authed = false;
      this.$router.push("/");
    },

    async ensureAuthAndAdmin() {
      this.setAuthedFromStorage();

      if (!this.authed) {
        this.openLoginModal();
        return;
      }

      try {
        await axios.get("/sanctum/csrf-cookie");
        const res = await axios.get("/api/isAdmin");

        if (!res.data?.isAdmin) {
          this.forceLogoutAndRedirect();
        }
      } catch (err) {
        console.error("Auth check failed", err);
        this.forceLogoutAndRedirect();
      }
    },

    async login(credentials) {
      this.logging = true;
      this.loginError = "";

      try {
        const response = await login(credentials);

        sessionStorage.setItem("user", JSON.stringify(response));
        this.$store.commit("updateUser", response);

        // UI hned
        this.authed = true;

        // zavřít modal
        this.hideLoginModal();

        // odpoj redirect handler (ať tě to po hide nehodí pryč)
        this.detachModalHiddenRedirect();

        // ✅ finální cleanup, aby sidebar nebyl pod backdropem
        setTimeout(() => {
          this.cleanupModalArtifacts();
        }, 0);

        // ověř admin
        await this.ensureAuthAndAdmin();
      } catch (err) {
        if (err.response?.status === 401) {
          this.loginError = "Nesprávné přihlašovací údaje";
        } else if (err.response?.status === 403) {
          this.loginError = "Ověřte si prosím svůj účet";
        } else {
          console.error(err);
          this.loginError = "Přihlášení se nezdařilo";
        }
      } finally {
        this.logging = false;
      }
    },
  },

  mounted() {
    if (this.$route.params?.productId) {
      this.showedMain = "edit";
    }

    this.setAuthedFromStorage();
    this.ensureAuthAndAdmin();
  },

  watch: {
    $route() {
      if (this.$route.params?.productId) {
        this.showedMain = "edit";
      }
      this.ensureAuthAndAdmin();
    },
  },

  beforeUnmount() {
    this.detachModalHiddenRedirect();
    this.cleanupModalArtifacts();
  },
};
</script>

<style lang="scss">
.administration {
  display: flex;
  position: relative;

  .sideBar {
    background: $gray-third;
    padding: 3rem 0;
    white-space: nowrap;
    margin-top: unset;

    > ul > li {
      padding: 1rem 3rem;
      border-bottom: 1px solid black;
    }
  }

  .mainWrapper {
    width: 100%;
    padding: 0 2rem;
  }
}
</style>
